import { useEffect, useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import { SplashScreen } from '@/shared/ui/components/SplashScreen';

import { useCustomAlerts } from '@/shared/lib/alert';

import { ROUTES } from '@/shared/constants';

/**
 * Залогиненный актёр открыл ссылку на чужой профиль (/actors/:id?profile_token=…):
 * этот экран предназначен только для кинокомпаний — уводим на главную с тостом.
 */
export const ActorProfileAccessRedirect = () => {
  const navigate = useNavigate();
  const { showCustomAlert } = useCustomAlerts();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    hasRedirected.current = true;

    showCustomAlert('Профиль актёра доступен только кинокомпаниям', {
      severity: 'error'
    });
    navigate(ROUTES.root, { replace: true });
  }, []);

  return <SplashScreen />;
};
